import React, {Component} from 'react';
import '../../styles/SideMenu.css';
import {client} from '../../Client';
import {NavLink} from 'react-router-dom';
import NewsToday from '../news/NewsToday';

class SideMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let sideMenuVisible = this.props.sideMenuVisible;
        let topbarBckColor = "#005BAB";
        if (client.getCurrentUser().bckcolor2 !== ""){
          topbarBckColor = client.getCurrentUser().bckcolor2;
        }
    
        return (<div className={sideMenuVisible ? "side menu no-print" : "side menu hide no-print"} style={{backgroundColor: topbarBckColor}}>

            <div className="ui fluid vertical pointing menu" id="sideMenu" tabIndex="0"
                 style={{overflow: 'hidden', outline: 'none', backgroundColor: topbarBckColor}}>

                {client.getCurrentUser().isroleattivita ? (<NavLink className='item' style={{backgroundColor: topbarBckColor}} to='/app/attivita'>
                    <i className="wait icon"></i> <span>Attività</span>
                </NavLink>) : null}
                {client.getCurrentUser().isrolegare ? (<NavLink className='item' style={{backgroundColor: topbarBckColor}} to='/app/gare'>
                    <i className="trophy icon"></i> <span>Gare/Offerte</span>
                </NavLink>) : null}
                {client.getCurrentUser().isrolecommesse ? (<NavLink className='item' style={{backgroundColor: topbarBckColor}} to='/app/commesse'>
                    <i className="shopping bag icon"></i> <span>Commesse</span>
                </NavLink>) : null}
                {client.getCurrentUser().isroledocumenti ? (<NavLink className='item' style={{backgroundColor: topbarBckColor}} to='/app/documenti'>
                    <i className="file word outline icon"></i> <span>Documenti</span>
                </NavLink>) : null}
                {client.getCurrentUser().isrolerubrica ? (<NavLink className='item' style={{backgroundColor: topbarBckColor}} to='/app/rubrica'>
                    <i className="users icon"></i> <span>Rubrica</span>
                </NavLink>) : null}
                {client.getCurrentUser().isrolemovimenti ? (<NavLink className='item' style={{backgroundColor: topbarBckColor}} to='/app/movimenti'>
                    <i className="euro icon"></i> <span>Movimenti</span>
                </NavLink>) : null}
                {client.getCurrentUser().isrolereport ? (<NavLink className='item' style={{backgroundColor: topbarBckColor}} to='/app/report'>
                    <i className="bar chart icon"></i> <span>Report</span>
                </NavLink>) : null}
                {client.getCurrentUser().isrolenews ? (<NavLink className='item' style={{backgroundColor: topbarBckColor}} to='/app/news'>
                    <i className="comments icon"></i> <span>Notizie</span>
                </NavLink>) : null}

                {client.getCurrentUser().isroleconfigurazione ? (<NavLink className='item' style={{backgroundColor: topbarBckColor}} to='/app/configurazione'>
                    <i className="wrench icon"></i> <span>Configurazioni</span>
                </NavLink>) : null}

            </div>
            {/* id="sidemenunews" */}
                <NewsToday title="Fate attenzione a" backgroundColor={topbarBckColor}  mode="all"></NewsToday>
        </div>)
    }
}

export default SideMenu;




/** WEBPACK FOOTER **
 ** ./src/components/main/SideMenu.js
 **/